<template>
<h1 class="title">
  <span class="icon-text">
    <span class="icon ">
      <img alt="logo" src="@/assets/logo-bat.png">
    </span>
    <span >
      Admin Reset
    </span>
  </span>
</h1>
<div class="field" :class="{warn: this.warnings }">
  <label class="label">Email</label>
  <input
    type="email"
    v-model="email"
    class="input"
    :class="{'is-danger': this.warn && this.warnings && 'email' in this.formErrors}"
    @keyup="this.warn = false  ; this.failed = false"
    required />
</div>
<div class="field" :class="{warn: this.warnings }">
  <label class="label">New Password</label>
  <input
    type="password"
    v-model="password"
    class="input"
    name="password"
    :class="{'is-danger': this.warn && this.warnings && 'password' in this.formErrors}"
    @keyup="this.warn = false  ; this.failed = false"
    required />
</div>
<div class="field" :class="{warn: this.warnings }">
  <label class="label">Repeat Password</label>
  <input
    type="password"
    v-model="repeatpassword"
    class="input"
    name="password"
    :class="{'is-danger': this.warn && this.warnings && 'password' in this.formErrors}"
    @keyup="this.warn = false  ; this.failed = false"
    required />
</div>
<div class="field" :class="{warn: this.warnings }">
  <label class="label">Reset Code (check your email)</label>
  <input
    type="text"
    v-model="code"
    class="input"
    :class="{'is-danger': this.warn && this.warnings && 'code' in this.formErrors}"
    @keyup="this.warn = false  ; this.failed = false"
    required />
</div>
<br>
<div class="buttons">
  <button class="button" @click="submitClicked">Submit</button>
</div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useLogin } from '@/js/auth.js'

export default {
    emits: ["submitted"],
    data() {
        return {
 	    email: "",
 	    code: "",
            warn: false,
            failed: false,
            password: "",
            repeatpassword: "",
        }
    },
    created() {
        this.email = this.previous
        if (this.$route.query.email){
            this.code = this.$route.query.email
        }
        if (this.$route.query.code){
            this.code = this.$route.query.code
        }
    },
    methods: {
        submitClicked() {
            if (this.warnings) {
                console.log("forms contains warnings...")
                this.warn = true
 	        return null
 	    } else {
                this.warn = false
            }
 	    const creds = {
 	        email: this.email,
 	        code: this.code,
                password: this.password
 	    }
            this.$emit("submitted", {stage: "confirmforgot", data: creds})
        },
    },
    computed: {
        ...mapState(useLogin, {"previous": "email"}),
        formErrors() {
            let state = {}
 	    if (!this.email.includes(".")){
                let email = {}
                email.error = true
                email.message = "email must contain a `.` symbol"
                state.email = email
 	    }
 	    if (!this.email.includes("@")){
                let email = {}
                email.error = true
                email.message = "email must contain a `@` symbol"
                state.email = email
 	    }
            if (this.email.length < 4){
                let email = {}
                email.error = true
                email.message = "email too short"
                state.email = email
 	    }
 	    if (this.code.length < 4){
                let code = {}
 		code.error = true
 		code.message = "code too short"
                state.code = code
 	    }
 	    return state
 	},
        warnings(){
            return Object.keys(this.formErrors).length > 0
        },
    },
}
</script>
